<template>
  <div class="engineer">
    <div class="chart_wrap">
      <div class="title">
        <h3>
          {{ $lange == "en" ? "Working days Input" : "工程师应工作天数" }}
        </h3>
      </div>
      <div class="content search">
        <el-date-picker
          v-model="year"
          type="year"
          placeholder="选择年"
          value-format="yyyy"
          size="mini"
          style="margin-right: 8px"
        >
        </el-date-picker>
        <el-button size="mini" @click="handleSearch">{{
          $lange == "en" ? "View" : "查看"
        }}</el-button>
      </div>
      <div class="content">
        <el-table size="mini" :data="workHours" border>
          <el-table-column
            prop="year"
            :label="$lange == 'en' ? 'Year' : '年份'"
            min-width="60"
          ></el-table-column>
          <el-table-column
            v-for="(month, idx) in months"
            :key="idx"
            :prop="month.value"
            :label="month.label"
            min-width="60"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div>
                <span v-if="!workEdit">{{ scope.row[month.value].days }}</span>
                <el-input
                  v-else
                  size="mini"
                  v-model="scope.row[month.value].days"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$lange == 'en' ? 'Operating' : '操作'"
            fixed="right"
            width="90"
          >
            <template>
              <el-button size="mini" @click="toggleWorkEdit">
                {{ rowEditName }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="chart_wrap">
      <EngineerStatus :codes="codes" />
    </div>
    <!--  -->
    <div class="chart_wrap second">
      <EngineerOutworkRatio :codes="codes" />
    </div>

    <div class="chart_wrap second">
      <EngineerOutworkTime :codes="codes" />
    </div>
    <div class="chart_wrap second">
      <EngineerOutworkDiff :codes="codes" />
    </div>
  </div>
</template>

<script>
// 外勤工程师报表
import moment from "moment";

import EngineerStatus from "./engineers/Status.vue";
import EngineerOutworkRatio from "./engineers/OutworkRatio.vue";
import EngineerOutworkTime from "./engineers/OutworkTime.vue";
import EngineerOutworkDiff from "./engineers/OutworkDiff.vue";

// const constantsTime = [
//   "一月",
//   "二月",
//   "三月",
//   "四月",
//   "五月",
//   "六月",
//   "七月",
//   "八月",
//   "九月",
//   "十月",
//   "十一月",
//   "十二月",
// ];

export default {
  name: "Engineer",
  components: {
    EngineerStatus,
    EngineerOutworkRatio,
    EngineerOutworkTime,
    EngineerOutworkDiff,
  },
  data() {
    // const months = new Array(12).fill(0).map((_, idx) => ({
    //   label: this.constantsTime[idx],
    //   value: `month-${idx + 1}`,
    // }));
    const monthCode = new Array(12).fill(0).map((_, idx) => idx + 1);

    return {
      constantsTime: [
        this.$lange == "en" ? "Jan" : "一月",
        this.$lange == "en" ? "Feb" : "二月",
        this.$lange == "en" ? "Mar" : "三月",
        this.$lange == "en" ? "Apr" : "四月",
        this.$lange == "en" ? "May" : "五月",
        this.$lange == "en" ? "Jun" : "六月",
        this.$lange == "en" ? "Jul" : "七月",
        this.$lange == "en" ? "Aug" : "八月",
        this.$lange == "en" ? "Sep" : "九月",
        this.$lange == "en" ? "Oct" : "十月",
        this.$lange == "en" ? "Nov" : "十一月",
        this.$lange == "en" ? "Dec" : "十二月",
      ],

      codes: [],
      // months: Object.freeze(months),
      months: [],
      monthCode: Object.freeze(monthCode),
      year: moment().format("YYYY"),

      workHours: [],
      bakWorkHours: [],
      workEdit: false,
      rawData: [], // 原数据
    };
  },
  created() {
    const months = new Array(12).fill(0).map((_, idx) => ({
      label: this.constantsTime[idx],
      value: `month-${idx + 1}`,
    }));
    this.months = Object.freeze(months);

    this.fetchEngineerCode();
    this.queryEmpWorkday(this.year);
  },
  computed: {
    rowEditName() {
      return this.workEdit
        ? this.$lange == "en"
          ? "Save"
          : "保存"
        : this.$lange == "en"
        ? "Edit"
        : "编辑";
    },
  },
  methods: {
    handleSearch() {
      this.queryEmpWorkday(this.year);
    },
    /**
     *
     * 过滤出只修改过days 的数据
     * @param {any[]} pre - 原数组
     * @param {any[]} cur - 修改后数组
     */
    findDiffData(pre, cur) {
      let newData = [];
      cur.forEach((item) => {
        if (!item.id) {
          newData.push(item);
        } else {
          const oldData = pre.find((old) => old.id === item.id);
          // 不存在该ID
          if (!oldData) return;
          else {
            const { days } = item;
            if (days !== oldData.days) {
              newData.push(item);
            } else {
              return;
            }
          }
        }
      });
      return newData;
    },
    /** @param {any[]} data - */
    checkType(data) {
      const regInt = /^\d+$/;
      if (data.some((i) => !regInt.test(i.days))) {
        return false;
      } else {
        return true;
      }
    },
    toggleWorkEdit() {
      if (!this.workEdit) {
        // 备份
        try {
          this.bakWorkHours = JSON.parse(JSON.stringify(this.workHours));
        } catch (e) {
          console.log(e.message);
          this.bakWorkHours = this.workHours.slice();
        }
      } else {
        console.log("保存内容", this.workHours);
        const data = this.workHours[0];
        const { year, ...rest } = data;
        console.log(year);
        const newData = this.findDiffData(this.rawData, Object.values(rest));
        console.log("过滤内容", newData);

        const valid = this.checkType(newData);
        if (!valid) {
          this.$message.warning("请输入整数");
          return;
        }
        if (!newData || newData.length < 1) {
          this.workHours = this.bakWorkHours.slice();
          this.workEdit = !this.workEdit;
          return;
        }
        this.batchSave(newData)
          .then((res) => {
            console.log("保存成功", res);
            this.$message.success("保存成功");
          })
          .catch((err) => {
            console.log(err);
            this.$message.error(err.message);
            // TODO: 保存失败恢复
            this.workHours = this.bakWorkHours.slice();
          });
      }

      this.workEdit = !this.workEdit;
    },
    async fetchEngineerCode() {
      const res = await this.ccRequest.do(
        "admin/dict/pageTree?code=engineer",
        {},
        "GET"
      );
      const engineers = res.rows.find((i) => i.code === "engineer");
      if (!engineers) return;
      this.codes = engineers.children;
    },

    async queryEmpWorkday(year) {
      const res = await this.ccRequest.do(
        "admin/fsb/employee/workday/query",
        { year },
        "GET"
      );

      this.rawData = Object.freeze(res.rows);

      let defaultData = this.monthCode.reduce(
        (pre, cur) => {
          pre[`month-${cur}`] = {
            year,
            month: cur,
            days: 0,
          };
          return pre;
        },
        { year }
      );

      const yearData = res.rows.reduce((pre, cur) => {
        if (cur.year == year) {
          const { id, month, days, year } = cur;
          pre[`month-${cur.month}`] = { id, month, days, year };
        }
        return pre;
      }, defaultData);
      console.log(yearData);
      this.workHours = [yearData];
      return res;
    },

    async batchSave(entries) {
      const res = await this.ccRequest.do(
        "admin/fsb/employee/workday/batchSave",
        entries,
        "POSTJSON"
      );
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
.engineer {
  box-sizing: border-box;
  background: #f3f3f4;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}
.charts {
  width: 100%;
}

.chart_wrap {
  margin-bottom: 8px;
  background-color: #fff;
}

.content {
  padding: 8px;
}
.title {
  border-bottom: 1px solid #e4e4e4;
  padding: 10px 20px;
}
</style>
